// extracted by css-extract-rspack-plugin
export default {"root":"root-T6E6ot","title":"title-FOC113","count":"count-IjwWZt"};